export default "__VITE_ASSET__Brl42IVV__"